export const FREE_CALL_CALENDAR_LINK =
  'https://calendly.com/ayble-team/learn-more-about-ayble';
export const LOCAL_STORAGE_USER_INFO_KEY = 'ayble-user-info';
export const GENDERS = ['Female', 'Male', 'Other', 'Prefer not to say'];
// Header heights: 14px/12px padding top and bottom around a 32px/26px logo
export const NAV_HEADER_HEIGHT_PX = 61;
export const MOBILE_NAV_HEADER_HEIGHT_PX = 51;
export const PROGRESS_BAR_HEIGHT_PX = 8;
